/* =============================================================
   PARENT-THEME JS SHIELD
   Some parent themes (Skin Toner, Dawn variants) have JS that
   removes or hides shopify-section elements they don't recognize.
   This shield watches for that and re-shows our .ely sections.
   ============================================================= */
(function() {
  'use strict';
  function unhide() {
    var els = document.querySelectorAll('.ely, .shopify-section:has(.ely)');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none') el.style.setProperty('display', 'block', 'important');
      if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
      if (parseFloat(cs.opacity) < 0.1) el.style.setProperty('opacity', '1', 'important');
      if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
      if (el.hasAttribute('aria-hidden') && el.getAttribute('aria-hidden') === 'true') {
        el.setAttribute('aria-hidden', 'false');
      }
    }
  }
  function start() {
    unhide();
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function(mutations) {
        var needsUnhide = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && (m.attributeName === 'style' || m.attributeName === 'class' || m.attributeName === 'hidden')) {
            needsUnhide = true; break;
          }
          if (m.type === 'childList' && (m.removedNodes.length || m.addedNodes.length)) {
            needsUnhide = true; break;
          }
        }
        if (needsUnhide) unhide();
      });
      try {
        obs.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden'],
          subtree: true,
          childList: true
        });
        // Auto-disconnect after 30s — by then parent theme JS has long settled
        setTimeout(function() { obs.disconnect(); unhide(); }, 30000);
      } catch (e) {}
    }
    // Belt-and-suspenders re-runs
    setTimeout(unhide, 100);
    setTimeout(unhide, 500);
    setTimeout(unhide, 1500);
    setTimeout(unhide, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Elycera AFM Disabler — product page interactivity
 * Lightweight, vanilla, no dependencies.
 * Safe to load on any page; each module checks for the elements it needs.
 */
(function () {
  'use strict';

  /* -------- Helpers -------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* -------- Quantity stepper (works with multiple instances) -------- */
  function initQty() {
    $$('[data-ely-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"], input[name="quantity"]');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-q]');
        if (!btn) return;
        var v = parseInt(input.value || '1', 10);
        if (isNaN(v)) v = 1;
        v = btn.dataset.q === '+' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* -------- Variant / bundle selector pricing -------- */
  function initVariants() {
    var form = $('form.ely-product-form');
    if (!form) return;
    var product;
    try {
      product = JSON.parse(document.getElementById('ely-product-json').textContent);
    } catch (err) { return; }

    var radios = $$('input[data-variant-id]', form);
    if (!radios.length) return;

    function setPrice(variant) {
      if (!variant) return;
      var priceEl = $('[data-ely-price]');
      var compareEl = $('[data-ely-compare]');
      var saveEl = $('[data-ely-save]');
      var stickyPrice = $('[data-ely-sticky-price]');
      var stickyCompare = $('[data-ely-sticky-compare]');
      var submit = form.querySelector('[type="submit"]');
      var fmt = window.Shopify && window.Shopify.formatMoney
        ? function (c) { return window.Shopify.formatMoney(c, '${{amount}}'); }
        : function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };

      if (priceEl) priceEl.textContent = fmt(variant.price);
      if (stickyPrice) stickyPrice.textContent = fmt(variant.price);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = fmt(variant.compare_at_price); compareEl.style.display = ''; }
        if (stickyCompare) { stickyCompare.textContent = fmt(variant.compare_at_price); stickyCompare.style.display = ''; }
        if (saveEl) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (stickyCompare) stickyCompare.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }

      if (submit) {
        if (variant.available) {
          submit.disabled = false;
          submit.removeAttribute('aria-disabled');
          var label = submit.dataset.labelAvailable || submit.textContent;
          // preserve arrow if exists
          var arrow = submit.querySelector('.arr');
          submit.firstChild && (submit.firstChild.nodeValue = label);
          if (arrow) submit.appendChild(arrow);
        } else {
          submit.disabled = true;
          submit.setAttribute('aria-disabled', 'true');
          submit.firstChild && (submit.firstChild.nodeValue = submit.dataset.labelSoldOut || 'Sold out ');
        }
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var id = parseInt(r.dataset.variantId, 10);
        var v = (product.variants || []).filter(function (x) { return x.id === id; })[0];
        // also write to product form's variant id input
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = id;
        setPrice(v);
        // update label highlight
        $$('[data-bundle-label]').forEach(function (lab) { lab.classList.remove('sel'); });
        var label = r.closest('[data-bundle-label]');
        if (label) label.classList.add('sel');
      });
    });
    // initial
    var checked = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    if (checked) {
      checked.checked = true;
      var initLabel = checked.closest('[data-bundle-label]');
      if (initLabel) initLabel.classList.add('sel');
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = checked.dataset.variantId;
      var initId = parseInt(checked.dataset.variantId, 10);
      var initV = (product.variants || []).filter(function (x) { return x.id === initId; })[0];
      setPrice(initV);
    }
  }

  /* -------- Vehicle fitment finder -------- */
  function initFitment() {
    var form = $('[data-ely-finder]');
    if (!form) return;
    var yearSel = form.querySelector('[data-finder-year]');
    if (yearSel && !yearSel.options.length || (yearSel && yearSel.options.length < 2)) {
      // populate year if empty
      var startYear = parseInt(form.dataset.yearEnd || '2024', 10);
      var endYear = parseInt(form.dataset.yearStart || '2007', 10);
      for (var y = startYear; y >= endYear; y--) {
        var opt = document.createElement('option');
        opt.value = y; opt.textContent = y;
        yearSel.appendChild(opt);
      }
    }
    var btn = form.querySelector('[data-finder-check]');
    var result = form.querySelector('[data-finder-result]');
    if (!btn || !result) return;

    var rows = window.ElyceraFit || [];
    btn.addEventListener('click', function () {
      var yr = (form.querySelector('[data-finder-year]') || {}).value;
      var mk = (form.querySelector('[data-finder-make]') || {}).value;
      var md = (form.querySelector('[data-finder-model]') || {}).value;
      if (!yr || !mk || !md) {
        result.className = 'finder-result no';
        result.textContent = 'Pick a year, make, and model to check fit.';
        return;
      }
      var match = rows.filter(function (r) {
        return r.model.toLowerCase() === md.toLowerCase()
          && parseInt(yr,10) >= r.yearFrom && parseInt(yr,10) <= r.yearTo;
      })[0];
      if (match) {
        result.className = 'finder-result ok';
        result.textContent = 'CONFIRMED FIT · ' + yr + ' ' + md + ' · ' + match.engine;
      } else {
        result.className = 'finder-result no';
        result.textContent = yr + ' ' + md + ' — text us your VIN to confirm fit.';
      }
    });
  }

  /* -------- Compatibility table filter / search -------- */
  function initCompat() {
    var table = $('[data-ely-compat-table]');
    if (!table) return;
    var rows = $$('[data-compat-row]', table);
    var chips = $$('[data-compat-filter]');
    var input = $('[data-compat-search]');
    var moreWrap = $('[data-compat-more]');
    var moreBtn = $('[data-compat-more-btn]');
    var PREVIEW = 8;     // rows shown by default before "Show all"
    var expanded = false;

    function apply() {
      var active = (chips.filter(function (c) { return c.classList.contains('on'); })[0] || {}).dataset || { compatFilter: 'all' };
      var filter = active.compatFilter || 'all';
      var q = (input && input.value || '').toLowerCase().trim();
      // Only collapse in the default view — once the shopper searches or picks a
      // filter chip, show every match so nothing relevant is hidden.
      var isDefault = filter === 'all' && !q;
      var collapse = isDefault && !expanded;
      var shown = 0, matchCount = 0;
      rows.forEach(function (row) {
        var type = row.dataset.type || '';
        var text = (row.textContent || '').toLowerCase();
        var match = (filter === 'all' || type === filter) && (!q || text.indexOf(q) !== -1);
        if (!match) { row.style.display = 'none'; return; }
        matchCount++;
        if (collapse && shown >= PREVIEW) { row.style.display = 'none'; }
        else { row.style.display = ''; shown++; }
      });
      if (moreWrap && moreBtn) {
        if (isDefault && matchCount > PREVIEW) {
          moreBtn.textContent = expanded ? 'Show fewer' : ('Show all ' + matchCount + ' models');
          moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          moreWrap.hidden = false;
        } else {
          moreWrap.hidden = true;
        }
      }
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.remove('on'); });
        c.classList.add('on');
        apply();
      });
    });
    if (input) input.addEventListener('input', apply);
    if (moreBtn) moreBtn.addEventListener('click', function () {
      expanded = !expanded;
      apply();
      if (!expanded && table.scrollIntoView) table.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    apply();
  }

  /* -------- Sticky ATC -------- */
  function initStickyAtc() {
    var bar = $('[data-ely-sticky]');
    if (!bar) return;
    var anchor = $('[data-ely-hero-end]') || $('.ely-hero');
    if (!anchor) return;
    document.body.classList.add('ely-sticky-pad');
    function update() {
      var r = anchor.getBoundingClientRect();
      if (r.bottom < 80) bar.classList.add('show');
      else bar.classList.remove('show');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Sticky ATC button: click the real product form's own submit button so it
    // adds whatever offer is currently selected (bundle radio + hidden quantity
    // input already reflect that), going through the exact same native submit
    // path the main Add to cart button uses — the cart drawer's document-level
    // capturing submit listener picks it up from there (AJAX add, bundle
    // tagging, drawer open), so there's no duplicated cart logic here.
    var stickyBtn = bar.querySelector('[data-ely-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        if (e && e.preventDefault) e.preventDefault();
        var form = $('form.ely-product-form');
        var realSubmit = form && form.querySelector('button[type="submit"][name="add"]');
        if (realSubmit) {
          if (realSubmit.disabled) return; // sold out — nothing to add
          realSubmit.click();
        }
      });
    }
  }

  /* -------- Bundle label click forwards to radio -------- */
  function initBundleLabels() {
    $$('[data-bundle-label]').forEach(function (lab) {
      lab.addEventListener('click', function (e) {
        var radio = lab.querySelector('input[type="radio"]');
        if (!radio) return;
        if (e.target !== radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }

  /* -------- Media gallery carousel (sliding track: swipe + drag + arrows) -------- */
  function initGallery() {
    var main = $('[data-ely-gallery-main]');
    if (!main) return;
    var track = main.querySelector('[data-ely-track]');
    if (!track) return;
    var n = track.querySelectorAll('.media-slide').length;
    if (n < 2) return;
    var thumbs = $$('[data-ely-thumb]');
    main.classList.add('is-carousel');

    var idx = 0;
    // Cache the track width. Reading clientWidth inside pointermove/up forces a
    // synchronous layout on every drag frame — interleaved with the transform
    // writes, that's layout thrash (~167ms forced reflow in PageSpeed). Width only
    // changes on resize/rotate, so measure once and refresh on those + at drag start.
    var cw = main.clientWidth;
    function w() { return cw; }
    function measure() { cw = main.clientWidth; }
    function setX(px, animate) {
      track.classList.toggle('animate', !!animate);
      track.style.transform = 'translateX(' + px + 'px)';
    }
    function show(i) {
      idx = Math.max(0, Math.min(n - 1, i));
      setX(-idx * w(), true);
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      if (thumbs[idx]) thumbs[idx].classList.add('active');
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var pn = main.querySelector('[data-ely-prev]');
    var nx = main.querySelector('[data-ely-next]');
    if (pn) pn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx - 1); });
    if (nx) nx.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx + 1); });

    // Finger-follow drag (Pointer Events = touch + mouse), snaps with animation
    var startX = null, baseX = 0, dragging = false;
    main.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-ely-prev],[data-ely-next]')) return;
      measure();
      startX = e.clientX; baseX = -idx * w(); dragging = true;
      track.classList.remove('animate');
      try { main.setPointerCapture(e.pointerId); } catch (_) {}
    });
    main.addEventListener('pointermove', function (e) {
      if (!dragging || startX === null) return;
      var x = baseX + (e.clientX - startX);
      var min = -(n - 1) * w();
      if (x > 0) { x *= 0.35; }                       // edge resistance
      else if (x < min) { x = min + (x - min) * 0.35; }
      track.style.transform = 'translateX(' + x + 'px)';
    });
    main.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = (startX === null) ? 0 : (e.clientX - startX);
      startX = null;
      var threshold = Math.min(80, w() * 0.18);
      if (dx <= -threshold) { show(idx + 1); }
      else if (dx >= threshold) { show(idx - 1); }
      else { show(idx); }                              // snap back
    });
    main.addEventListener('pointercancel', function () { dragging = false; startX = null; show(idx); });

    main.setAttribute('tabindex', '0');
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
    });
    window.addEventListener('resize', function () { measure(); setX(-idx * w(), false); });
  }

  /* -------- Smooth in-page anchor scroll -------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var hash = a.getAttribute('href');
      if (hash.length < 2) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  /* -------- Boot -------- */
  function boot() {
    initQty();
    initVariants();
    initBundleLabels();
    initFitment();
    initCompat();
    initStickyAtc();
    initGallery();
    initAnchors();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
